import WangWang from "@/components/WangWang";
import OrderDTO from "@/dto/order/OrderDTO";
import React from "react";
import WithPopoverTip from "../WithPopoverTip";
import { observer } from "mobx-react-lite";
import { isAnyOrderWithTaoTianReissueTag } from "@/utils/OrderTagUtils";

interface TaobaoBuyerUsernameProps {
    order: OrderDTO;

    onSearch?: () => void;
}

const TaobaoBuyerUsername: React.FC<TaobaoBuyerUsernameProps> = observer(function (props) {
    const { order, onSearch } = props;

    const buyerUsername = order.buyerUsername;
    const buyerNickname = order.buyerNickname;
    const bizDomain = "taobao";

    const hasReissueTag = isAnyOrderWithTaoTianReissueTag([order]);

    if (hasReissueTag) return <span>{buyerNickname ?? buyerUsername}</span>;

    if (buyerNickname && buyerUsername) {
        return (
            <WithPopoverTip
                onSearch={onSearch}
                otherTip={<div className="text-gray text-small">买家ID: {buyerUsername}</div>}
            >
                <WangWang nick={buyerNickname} openId={buyerUsername} bizDomain={bizDomain} />
            </WithPopoverTip>
        );
    }

    return (
        <WithPopoverTip onSearch={onSearch}>
            <WangWang nick={buyerUsername} bizDomain={bizDomain} />
        </WithPopoverTip>
    );
});

export default TaobaoBuyerUsername;
